import { render, staticRenderFns } from "./memCardType.vue?vue&type=template&id=c5a488b8&scoped=true"
import script from "./memCardType.vue?vue&type=script&lang=js"
export * from "./memCardType.vue?vue&type=script&lang=js"
import style0 from "./memCardType.vue?vue&type=style&index=0&id=c5a488b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a488b8",
  null
  
)

export default component.exports